import { memo } from "react";
import { Button } from "../shared";
import { useTrackingConsent } from "../../hooks/shared/tracking-consent/useTrackingConsent";

export const TrackingConsentDialog = memo(function TrackingConsent() {
    const { shouldAskForConsent, giveConsent, withdrawConsent } = useTrackingConsent();

    if (!shouldAskForConsent) return null;

    return (
        <div className="tracking-consent-dialog card-bg fixed bottom-4 left-4 z-50 m-4 flex min-w-sm max-w-[75%] flex-col items-center justify-between gap-2 rounded-lg border border-primary/20 p-4 shadow-lg transition-all duration-300 md:max-w-lg md:flex-row">
            <p className="text-sm text-dark">
                Help us improve your experience by allowing analytics. It helps us build better features and optimize
                performance throughout!
            </p>
            <div className="button-group flex-col flex gap-2 min-w-[150px]">
                <Button variant="primary" size="sm" className="text-nowrap tracking-tight" onClick={giveConsent}>
                    Yes, improve InfiniFi!
                </Button>
                <Button variant="secondary" size="sm" className="text-nowrap tracking-tight" onClick={withdrawConsent}>
                    Not now
                </Button>
            </div>
        </div>
    );
});

TrackingConsentDialog.displayName = "TrackingConsentDialog";
